// extracted by mini-css-extract-plugin
export default {"zoomModal":"Y7-z"};